import { useCallback } from 'react';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { IFormField } from '../../../view-models/form.view-model';
import { companyStateJ } from '../../../services/state/CompanyStateJ';
import { isPortfolioCompany } from '../../../data-models/company.data-model';
import { useAtomValue } from 'jotai';

export function useCompanyEditPerms(companyId: number) {
  const company = useAtomValue(companyStateJ(companyId));
  const isPortco = Boolean(company) && isPortfolioCompany(company!);
  const canEdit = !isPortco || PermissionService.get().hasPermission(PermissionKey.canEditPortfolioCompany);

  return useCallback(
    (fields: IFormField<unknown>[]) => {
      if (canEdit) {
        return fields;
      }
      return fields.map((field) => {
        return { ...field, disabled: true, placeholder: '' };
      });
    },
    [canEdit]
  );
}
